/**
 * Deposit policy type discriminator
 */
export enum DepositPolicyTypeEnum {
	FIXED = 'fixed',
	PERCENTAGE = 'percentage',
	DAYS_WORTH = 'days_worth',
}
